export default __webpack_public_path__ + "static/media/storyreveal.768967cc.webm";